import { BaseRepository } from '../../infra/base.repository'
import { ConfigService } from '../../infra/config'
import type { CreatePasswordDto } from './dto/create-password.dto'
import type { LoginPasswordDTO } from './dto/login-password.dto'
import type { LoginSMSDTO } from './dto/login-sms.dto'
import type { requestSMSDTO } from './dto/request-sms.dto'
import type { UpdatePasswordDto } from './dto/update-password.dto'

export class AuthRepository extends BaseRepository<any> {
    constructor(
        config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.userApiUrl + '/auth2', token, cache)
    }

    // =============== signup ===============

    async requestSignupBySMS(requestSMS: requestSMSDTO) {
        const { json, statusCode, message } = await this.request.post(this.url + '/signin/sms', requestSMS)
        if (String(statusCode).substring(0, 1) === '2') return
        throw message
    }

    // =============== login ===============

    async requestLoginByEmail(email: string, returnURL: string) {
        const { json, statusCode, message } = await this.request.post(this.url + '/login/email/request', {
            email,
            url: returnURL,
        })
        if (String(statusCode).substring(0, 1) === '2') return
        throw message
    }

    async requestLoginBySMS(requestSMS: requestSMSDTO) {
        const { json, statusCode, message } = await this.request.post(this.url + '/login/sms/request', requestSMS)
        if (String(statusCode).substring(0, 1) === '2') return
        throw message
    }

    async requestLoginByToken(userId: string) {
        const { json, statusCode, message } = await this.request.post(this.url + '/login/token/request?token=' + this.resolvedToken, { userId })
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async loginBySMS(loginSms: LoginSMSDTO) {
        const { json, statusCode, message } = await this.request.post(this.url + '/login/sms', loginSms)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async loginByPassword(loginPasswordDto: LoginPasswordDTO) {
        const { json, statusCode, message } = await this.request.post(this.url + '/login/password', loginPasswordDto)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async updatePassword(updatePasswordDto: UpdatePasswordDto) {
        const { json, statusCode, message } = await this.request.patch(this.url + '/login/password/?token=' + this.resolvedToken, updatePasswordDto)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async createPassword(createPasswordDto: CreatePasswordDto) {
        const { json, statusCode, message } = await this.request.post(this.url + '/login/password/create/?token=' + this.resolvedToken, createPasswordDto)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    // =============== token ===============

    async invalidateTokens() {
        const { json, statusCode, message } = await this.request.get(this.url + '/token/invalidate?token=' + this.resolvedToken)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async refreshToken(token: string) {
        const { json, statusCode, message } = await this.request.get(this.url + '/token/refresh/?token=' + token)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getCompanyToken(companyId: string, token: string) {
        const { json, statusCode, message } = await this.request.get(this.url + '/token/company/' + companyId + '?token=' + token)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
